/**
 * i18n setup for OneFDP.
 *
 * - Default language: RO (Romanian customers are majority).
 * - Language detection: localStorage > browser navigator > default RO.
 * - Toggle persisted in localStorage under key `i18nextLng`.
 * - Translation style: professional B2B (formal verbs).
 *
 * Phase 1 (this commit) covers public-facing pages:
 *   Landing, Login, Register, Gallery, common Navbar/Footer.
 * Phase 2 will add: dashboards, simulate, detail, profile pages.
 * Phase 3 will add: admin pages + transactional emails.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import roCommon from "./locales/ro.json";
import enCommon from "./locales/en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ro: { translation: roCommon },
      en: { translation: enCommon },
    },
    // Per Marius decision (06.06.2026): default RO regardless of browser locale.
    // English is opt-in via the navbar toggle. This protects existing Romanian
    // customers who don't expect language switching on first visit.
    lng: "ro",
    fallbackLng: "ro",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Only honour explicit user choice persisted in localStorage.
      // Skip navigator/htmlTag detection to keep RO as the locked default.
      order: ["localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    saveMissing: false,
    returnNull: false,
  });

export default i18n;
